import React from 'react';

export default function UpcomingList({ isLoading, product }) {
  const resultsRender = [];

  for (var i = 0; i < product.length; i += 4) {
    resultsRender.push(
      <section key={i} className="section section-lg">
        <div className="container container--xl">
          <div className="grid">
            {product.slice(i, i + 4).map((product) => (
              <article
                key={product.id}
                className="card grid__col-xs-12 grid__col-md-6 grid__col-lg-3"
              >
                <a href={product.external_link} target="_blank">
                  <img
                    src={product.image}
                    className="card__media"
                    alt={product.alt}
                  />
                </a>
                <section className="card__body">
                  <a href={product.external_link} target="_blank">
                    <h3 className="h4 card__title">{product.title}</h3>
                  </a>
                  <p
                    className="card__description wysiwyg"
                    dangerouslySetInnerHTML={{ __html: product.description }}
                  ></p>
                  <a
                    className="btn btn--naked btn--icon"
                    href={product.external_link}
                    target="_blank"
                  >
                    {product.external_link_text}
                    <i className="icon-external-link"></i>
                  </a>
                </section>
              </article>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <>
      {resultsRender}
      <section className="section section-lg">
        <div className="container container--xl">
          <hr className="section__hr" />
        </div>
      </section>
    </>
  );
}
